import React from "react";
var __jsx = React.createElement;
import { Button } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ImageDialog } from 'components/common/ImageDialog';
import { HoverButton } from 'components/common/material-ui/custom-components';
import { CompulsoryButtonContainer, Container, EditIcon, HoverButtonContainer, ImageHover, Img, TrashIcon, ViewContainer } from './ImagePreview.style';

var ImagePreview = function ImagePreview(_ref) {
  var imageData = _ref.imageData,
      onClickEdit = _ref.onClickEdit,
      onClickRemove = _ref.onClickRemove,
      onConfirm = _ref.onConfirm,
      onRemove = _ref.onRemove,
      _ref$compulsory = _ref.compulsory,
      compulsory = _ref$compulsory === void 0 ? false : _ref$compulsory,
      _ref$includedModal = _ref.includedModal,
      includedModal = _ref$includedModal === void 0 ? true : _ref$includedModal;

  var _useState = useState(includedModal && compulsory && isEmpty(imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl)),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var handleEditClick = function handleEditClick() {
    setOpenModal(includedModal);

    if (onClickEdit === undefined) {
      return;
    }

    onClickEdit();
  };

  var handleRemoveClick = function handleRemoveClick() {
    if (onClickRemove === undefined) {
      return;
    }

    onClickRemove();
  };

  var handleConfirm = function handleConfirm(newImageData) {
    setOpenModal(false);

    if (onConfirm === undefined) {
      return;
    }

    onConfirm(newImageData);
  };

  var handleClose = function handleClose() {
    setOpenModal(false);

    if (imageData === undefined || isEmpty(imageData.imgUrl)) {
      if (onRemove === undefined) {
        return;
      }

      onRemove();
    }
  };

  var UploadButton = function UploadButton() {
    if (openModal || !includedModal || !isEmpty(imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl)) {
      return null;
    }

    return compulsory ? __jsx(CompulsoryButtonContainer, null, __jsx(Button, {
      variant: "outlined",
      color: "inherit",
      onClick: function onClick() {
        return setOpenModal(true);
      }
    }, __jsx(FormattedMessage, {
      id: 'image-modal.compulsory-button'
    }))) : __jsx(Button, {
      variant: "outlined",
      color: "primary",
      onClick: function onClick() {
        return setOpenModal(true);
      }
    }, __jsx(FormattedMessage, {
      id: 'image-modal.upload-button'
    }));
  };

  return __jsx(Container, null, __jsx(UploadButton, null), __jsx(ImageDialog, {
    open: includedModal && openModal,
    initialData: imageData,
    onClose: handleClose,
    onConfirm: handleConfirm
  }), (imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl) !== undefined && __jsx(ViewContainer, null, __jsx(ImageHover, null, __jsx(HoverButtonContainer, null, __jsx(HoverButton, {
    color: "primary",
    variant: "outlined",
    startIcon: __jsx(EditIcon, null),
    onClick: handleEditClick
  }, __jsx(FormattedMessage, {
    id: "image-rich-text.edit"
  })), compulsory === false && __jsx(HoverButton, {
    color: "primary",
    variant: "outlined",
    startIcon: __jsx(TrashIcon, null),
    onClick: handleRemoveClick
  }, __jsx(FormattedMessage, {
    id: "image-rich-text.delete"
  })))), __jsx(Img, {
    src: imageData.imgUrl,
    "data-testid": "image-block-image"
  })));
};

export default ImagePreview;